// extracted by mini-css-extract-plugin
module.exports = {"Bio":"Bio_Bio__1ks_2","nostyle":"Bio_nostyle__3fK8-"};